module.exports = __webpack_public_path__ + "static/media/fly0154.75954f32.webp";